import * as React from 'react';

type FormProps = { onSubmit: () => void } & Omit<
  React.HTMLProps<HTMLFormElement>,
  'onSubmit'
>;

const Form: React.FC<React.PropsWithChildren<FormProps>> = ({
  onSubmit,
  children,
  ...rest
}) => {
  const onSubmitNative: React.FormEventHandler<HTMLFormElement> =
    React.useCallback(
      (e) => {
        e.preventDefault();
        onSubmit();
      },
      [onSubmit]
    );

  return (
    <form onSubmit={onSubmitNative} {...rest}>
      {children}
    </form>
  );
};

export default Form;
